var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeImmutable } from "../../core";
import { Availability } from "../Availability";
import { perRestaurant } from "../../di";
let ModifierItemTypeAvailabilityService = class ModifierItemTypeAvailabilityService {
    constructor() {
        makeImmutable(this);
    }
    availability(modifierItemType, parameterSet) {
        const { availabilitySpec, pricing } = modifierItemType;
        switch (availabilitySpec.type) {
            case "TemporarilyUnavailable":
                return Availability.unavailable("TemporarilyUnavailable");
            case "HiddenModifierItem":
                return Availability.unavailable("Hidden");
        }
        const parametric = Availability.parametrized({
            unavailabilityReason: "ParametrizedAvailability",
            parametrization: availabilitySpec.availabilityParametrization,
            parameterSet,
        });
        const price = Availability.parametrized({
            unavailabilityReason: "PriceAvailability",
            parametrization: pricing.map(() => true),
            parameterSet,
        });
        return Availability.composite([parametric, price]);
    }
};
ModifierItemTypeAvailabilityService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [])
], ModifierItemTypeAvailabilityService);
export { ModifierItemTypeAvailabilityService };
